import { render, staticRenderFns } from "./nowNextUp.vue?vue&type=template&id=0055faf4"
import script from "./nowNextUp.vue?vue&type=script&lang=js"
export * from "./nowNextUp.vue?vue&type=script&lang=js"
import style0 from "./nowNextUp.vue?vue&type=style&index=0&id=0055faf4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports